(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-guide"]) return;
  try {
    
	document.addEventListener('DOMContentLoaded', () => {
		const triggers = document.querySelectorAll('.style-guide a[href]');
		const contents = document.querySelectorAll('.style-guide div[id]');

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();

				const id = trigger.getAttribute('href').replace('#', '');

				triggers.forEach((trigger) => trigger.classList.remove('active'));
				trigger.classList.add('active');

				contents.forEach((content) => {
					if (!content.classList.contains('hidden')) content.classList.add('hidden');
					if (content.id === id) content.classList.remove('hidden');
				});
			});
		});
	});

  } catch(e) { console.error(e); }
})();
})();
